module.exports = __webpack_public_path__ + "img/hexa_black_red.9b6945a3.png";